import type { Recipe } from '../../domain/recipe';

// DE: Asiatische Abendessen für vier Portionen (Abendessen plus Mittagessen am nächsten Tag).
// EN: Asian dinners for four portions (dinner plus the next day's lunch).
// prettier-ignore
export const ASIAN_RECIPES: readonly Recipe[] = [
  {
    id: 'fried_rice', name: 'Смажений рис з яйцем, тофу та овочами', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Gebratener Reis mit Ei, Tofu und Gemüse',
    activeMinutes: 15, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'rice', quantity: 120 }, { productId: 'eggs', quantity: 6 }, { productId: 'tofu', quantity: 200 },
      { productId: 'veg_mix', quantity: 600 }, { productId: 'spring_onion', quantity: 1 },
      { productId: 'soy_sauce', quantity: 40 }, { productId: 'oil', quantity: 30 },
    ],
    steps: [
      'Зварити рис і дати йому охолонути (можна вчорашній).',
      'Обсмажити тофу кубиками, додати заморожені овочі та смажити 5 хвилин.',
      'Додати рис, зробити місце в сковороді, вбити яйця й перемішати.',
      'Заправити соєвим соусом і посипати зеленою цибулею.',
    ],
    stepsDe: [
      'Reis kochen und abkühlen lassen (Reis vom Vortag geht auch).',
      'Tofu in Würfeln anbraten, TK-Gemüse dazugeben und 5 Minuten braten.',
      'Reis dazugeben, in der Pfanne Platz schaffen, Eier hineinschlagen und verrühren.',
      'Mit Sojasoße abschmecken und mit Frühlingszwiebeln bestreuen.',
    ],
  },
  {
    id: 'chickpea_curry', name: 'Каррі з нутом і шпинатом', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Kichererbsen-Curry mit Spinat',
    activeMinutes: 10, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'chickpeas', quantity: 800 }, { productId: 'coconut_milk', quantity: 400 },
      { productId: 'canned_tomatoes', quantity: 400 }, { productId: 'spinach', quantity: 450 },
      { productId: 'rice', quantity: 80 }, { productId: 'curry', quantity: 10 },
    ],
    steps: [
      'Поставити варитися рис.',
      'Прогріти каррі на сухій сковороді, додати томати й кокосове молоко.',
      'Додати нут і шпинат, тушкувати 10 хвилин.',
      'Подавати з рисом.',
    ],
    stepsDe: [
      'Reis aufsetzen.',
      'Currypulver in einer trockenen Pfanne anrösten, Tomaten und Kokosmilch dazugeben.',
      'Kichererbsen und Spinat dazugeben und 10 Minuten köcheln lassen.',
      'Mit Reis servieren.',
    ],
  },
  {
    id: 'salmon_noodles', name: 'Рисова локшина з лососем та овочами', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Reisnudeln mit Lachs und Gemüse',
    activeMinutes: 10, totalMinutes: 15, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    ingredients: [
      { productId: 'rice_noodles', quantity: 120 }, { productId: 'salmon', quantity: 500 },
      { productId: 'veg_mix', quantity: 750 }, { productId: 'soy_sauce', quantity: 50 },
      { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Залити локшину окропом на 5 хвилин.',
      'Обсмажити лосось шматочками, додати заморожені овочі.',
      'Додати локшину й соєвий соус, перемішати.',
    ],
    stepsDe: [
      'Reisnudeln 5 Minuten in kochendem Wasser ziehen lassen.',
      'Lachs in Stücken anbraten, TK-Gemüse dazugeben.',
      'Nudeln und Sojasoße dazugeben und vermengen.',
    ],
  },
  {
    id: 'tofu_broccoli', name: 'Тофу з броколі, горошком і рисом', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Tofu mit Brokkoli, Erbsen und Reis',
    activeMinutes: 15, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'tofu', quantity: 400 }, { productId: 'broccoli', quantity: 500 }, { productId: 'peas', quantity: 300 },
      { productId: 'eggs', quantity: 4 }, { productId: 'rice', quantity: 120 }, { productId: 'soy_sauce', quantity: 40 },
      { productId: 'garlic', quantity: 10 }, { productId: 'ginger', quantity: 10 }, { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Поставити варитися рис.',
      'Обсмажити тофу до скоринки, додати часник та імбир.',
      'Додати броколі й горошок, смажити 5 хвилин, влити збиті яйця.',
      'Заправити соєвим соусом, подавати з рисом.',
    ],
    stepsDe: [
      'Reis aufsetzen.',
      'Tofu knusprig anbraten, Knoblauch und Ingwer dazugeben.',
      'Brokkoli und Erbsen 5 Minuten mitbraten, verquirlte Eier unterrühren.',
      'Mit Sojasoße abschmecken und mit Reis servieren.',
    ],
  },
  {
    id: 'shrimp_noodles', name: 'Рисова локшина з креветками та овочами', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Reisnudeln mit Garnelen und Gemüse',
    activeMinutes: 15, totalMinutes: 20, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'rice_noodles', quantity: 120 }, { productId: 'shrimp', quantity: 500 },
      { productId: 'veg_mix', quantity: 750 }, { productId: 'soy_sauce', quantity: 50 },
      { productId: 'garlic', quantity: 10 }, { productId: 'oil', quantity: 40 }, { productId: 'eggs', quantity: 4 },
    ],
    steps: [
      'Залити локшину окропом на 5 хвилин.',
      'Обсмажити часник і креветки 3 хвилини, додати овочі.',
      'Додати локшину, соєвий соус і збиті яйця, перемішати до готовності яєць.',
    ],
    stepsDe: [
      'Reisnudeln 5 Minuten in kochendem Wasser ziehen lassen.',
      'Knoblauch und Garnelen 3 Minuten anbraten, Gemüse dazugeben.',
      'Nudeln, Sojasoße und verquirlte Eier dazugeben und rühren, bis die Eier gestockt sind.',
    ],
  },
  {
    id: 'thai_soup', name: 'Тайський суп з креветками та кокосовим молоком', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Thailändische Suppe mit Garnelen und Kokosmilch',
    activeMinutes: 15, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'coconut_milk', quantity: 400 }, { productId: 'shrimp', quantity: 500 },
      { productId: 'mushrooms', quantity: 400 }, { productId: 'rice_noodles', quantity: 100 },
      { productId: 'veg_mix', quantity: 500 }, { productId: 'lemon', quantity: 50 },
      { productId: 'ginger', quantity: 20 }, { productId: 'broth', quantity: 2 }, { productId: 'soy_sauce', quantity: 30 },
    ],
    steps: [
      'Довести до кипіння 1 л води з бульйонними кубиками й імбиром.',
      'Додати гриби, овочі та кокосове молоко, варити 5 хвилин.',
      'Додати креветки й локшину, варити ще 3 хвилини.',
      'Заправити соком лимона й соєвим соусом.',
    ],
    stepsDe: [
      '1 l Wasser mit Brühwürfeln und Ingwer aufkochen.',
      'Pilze, Gemüse und Kokosmilch dazugeben und 5 Minuten kochen.',
      'Garnelen und Nudeln dazugeben und weitere 3 Minuten kochen.',
      'Mit Zitronensaft und Sojasoße abschmecken.',
    ],
  },
  {
    id: 'teriyaki_salmon', name: 'Лосось теріякі з рисом і броколі', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Teriyaki-Lachs mit Reis und Brokkoli',
    activeMinutes: 10, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'salmon', quantity: 500 }, { productId: 'rice', quantity: 120 }, { productId: 'broccoli', quantity: 500 },
      { productId: 'peas', quantity: 200 }, { productId: 'soy_sauce', quantity: 50 }, { productId: 'honey', quantity: 15 },
      { productId: 'ginger', quantity: 10 },
    ],
    steps: [
      'Поставити варитися рис, броколі й горошок готувати на парі.',
      'Змішати соєвий соус, мед і тертий імбир.',
      'Обсмажити лосось по 3 хвилини з кожного боку, залити соусом і дати загуснути.',
    ],
    stepsDe: [
      'Reis aufsetzen, Brokkoli und Erbsen dämpfen.',
      'Sojasoße, Honig und geriebenen Ingwer verrühren.',
      'Lachs von jeder Seite 3 Minuten braten, mit der Soße übergießen und eindicken lassen.',
    ],
  },
  {
    id: 'tofu_curry', name: 'Овочеве каррі з тофу та нутом', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Gemüsecurry mit Tofu und Kichererbsen',
    activeMinutes: 10, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'tofu', quantity: 400 }, { productId: 'coconut_milk', quantity: 400 },
      { productId: 'veg_mix', quantity: 750 }, { productId: 'chickpeas', quantity: 400 },
      { productId: 'curry', quantity: 10 }, { productId: 'rice', quantity: 80 },
    ],
    steps: [
      'Поставити варитися рис.',
      'Обсмажити тофу з каррі, додати овочі та нут.',
      'Влити кокосове молоко й тушкувати 10 хвилин.',
    ],
    stepsDe: [
      'Reis aufsetzen.',
      'Tofu mit Currypulver anbraten, Gemüse und Kichererbsen dazugeben.',
      'Kokosmilch angießen und 10 Minuten köcheln lassen.',
    ],
  },
  {
    id: 'dal', name: 'Дал з червоної сочевиці та шпинату', cuisine: 'asian', meal: 'dinner',
    nameDe: 'Dal aus roten Linsen mit Spinat',
    activeMinutes: 10, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    ingredients: [
      { productId: 'lentils', quantity: 320 }, { productId: 'canned_tomatoes', quantity: 400 },
      { productId: 'coconut_milk', quantity: 200 }, { productId: 'spinach', quantity: 450 },
      { productId: 'broth', quantity: 1 }, { productId: 'curry', quantity: 10 },
    ],
    steps: [
      'Промити сочевицю.',
      'Залити сочевицю 800 мл води з бульйонним кубиком і каррі, варити 15 хвилин.',
      'Додати томати, кокосове молоко та шпинат, варити ще 5 хвилин.',
    ],
    stepsDe: [
      'Linsen waschen.',
      'Linsen mit 800 ml Wasser, Brühwürfel und Currypulver 15 Minuten kochen.',
      'Tomaten, Kokosmilch und Spinat dazugeben und weitere 5 Minuten kochen.',
    ],
  },
];
